import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TemplateService } from '../../../../../../core/lists/_services/template.service';

interface AllowedCompleter {
  label: string;
  entity_type: string;
  allow_all_relation_categories: boolean;
  relation_categories: any[];
  allControl?: FormControl;
  categoryControl?: FormControl;
}
@Component({
  selector: 'kt-entities-dialog',
  templateUrl: './entities-dialog.component.html',
  styleUrls: ['./entities-dialog.component.scss'],
})
export class EntitiesDialogComponent implements OnInit {
  categoryControl = new FormControl({ value: null, disabled: true }, Validators.required);
  getCategoriesAutoComplete$ = (entityType: string) => {
    return (): Observable<any> => {
      return this.templateService.getRelationTypes([entityType]);
    };
  };
  entitiesExist = false;
  constructor(
    public dialogRef: MatDialogRef<EntitiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      allowed_completers: AllowedCompleter[];
    },
    private templateService: TemplateService,
  ) {}
  allowed_completers: AllowedCompleter[] = [
    {
      label: 'Doctor',
      entity_type: 'DOCTOR',
      allow_all_relation_categories: false,
      relation_categories: [],
    },
    {
      label: 'Facility',
      entity_type: 'FACILITY',
      allow_all_relation_categories: false,
      relation_categories: [],
    },
    {
      label: 'Patient',
      entity_type: 'PATIENT',
      allow_all_relation_categories: false,
      relation_categories: [],
    },
    {
      label: 'Client',
      entity_type: 'CLIENT',
      allow_all_relation_categories: false,
      relation_categories: [],
    },
  ];

  ngOnInit(): void {
    const existingCompleters = this.data?.allowed_completers || [];

    this.allowed_completers = this.allowed_completers.map((entity) => {
      const existing = existingCompleters.find((item) => item.entity_type === entity.entity_type);
      const allControl = new FormControl(existing?.allow_all_relation_categories ?? false);

      const categoryControl = new FormControl(
        existing?.allow_all_relation_categories ? [] : existing?.relation_categories ?? [],
        Validators.required,
      );

      // Disable categories when "All" is initially true
      if (allControl.value) {
        categoryControl.disable();
      }

      // Toggle categories input based on "All"
      allControl.valueChanges.subscribe((all) => {
        if (all) {
          categoryControl.setValue([]);
          categoryControl.disable();
        } else {
          categoryControl.enable();
        }
      });

      return {
        ...entity,
        allow_all_relation_categories: existing?.allow_all_relation_categories ?? false,
        relation_categories: existing?.relation_categories ?? [],
        allControl,
        categoryControl,
      };
    });
  }

  isEntityFilled(entity: AllowedCompleter): boolean {
    const all = entity.allControl?.value === true;
    const categories = entity.categoryControl?.value || [];
    return all || categories.length > 0;
  }

  isSubmitDisabled(): boolean {
    return !this.allowed_completers.some((entity) => this.isEntityFilled(entity));
  }

  formatCustomObject(object: { label: string; value: any }): string {
    return object?.label || '';
  }
  entitiesLabelFormatter(object: {
    id: number;
    entity_type: string;
    isAll: boolean;
    name: string;
  }) {
    return object?.name || '';
  }
  entitiesFormatter(object: { id: number; entity_type: string; isAll: boolean; name: string }) {
    return object?.name || '';
  }
  cancel() {
    this.dialogRef.close();
  }
  submit(): void {
    const result = this.allowed_completers
      .filter((entity) => this.isEntityFilled(entity))
      .map((entity) => {
        const allowAll = entity.allControl?.value === true;

        return {
          entity_type: entity.entity_type,
          allow_all_relation_categories: allowAll,
          relation_categories: allowAll ? [] : entity.categoryControl?.value || [],
        };
      });

    this.dialogRef.close({
      allowed_completers: result,
    });
  }
}
